import React from 'react';

const HighlightFirstMatch = ({
    text = '',
    highlight = '',
    className = '',
    spanClassName = '',
    style = {},
}) => {
    const index = text.indexOf(highlight);
    if (index === -1) return text;

    return (
        <span className={className}>
            {text.substring(0, index)}
            <span className={spanClassName} style={style}>
                {highlight}
            </span>
            {text.substring(index + highlight.length)}
        </span>
    );
};

export default HighlightFirstMatch;
